import React, { useState } from "react";
import styles from "./Product.module.css";
import { Image } from "react-bootstrap";
import { BsCaretDownFill } from "react-icons/bs";
import { FaStar } from "react-icons/fa";
import { FaPlay } from "react-icons/fa6";
import { Link, useNavigate } from "react-router-dom";
import { GoPlus } from "react-icons/go";
import { GrSubtract } from "react-icons/gr";
import { FaCartPlus } from "react-icons/fa";
import { FaCheck } from "react-icons/fa6";
import { Player } from "video-react"; // Or any other player you're using
import "video-react/dist/video-react.css"; // Required if using video-react
const productlist = [{ id: 1, name: "Home Clean" }];

export default function ProductList({ selectedService }) {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  console.log("selectedService", selectedService);

  return (
    <div className={styles.productlistContainer}>
      <div className={styles.productlistRow}>
        <div className={styles.productlistItem}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <h3> Bestselling Packages</h3>
            <Link
              to="/priceListPage" // replace with your price list URL
              className="btn btn-outline-primary btn-sm"
              style={{
                fontSize: 14,
                fontWeight: 600,
                width: 100,
                height: 30,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#b0e8ff",
                border: "none",
                color: "#fff",
              }}
            >
              Price List
            </Link>
          </div>
          {selectedService &&
            selectedService.map((serviceItem, index) => (
              <>
                <div className={styles.productIteemCard}>
                  <div className={styles.productItemRow}>
                    <div className={styles.productContent}>
                      <div className={styles.desktopPackage}>
                        <div style={{ display: "flex" }}>
                          <BsCaretDownFill
                            size={20}
                            style={{ marginTop: 0 }}
                            color="#156508"
                          />{" "}
                          <span style={{ marginLeft: 10, color: "#2062AF" }}>
                            Package{" "}
                          </span>
                          <span
                            style={{
                              marginLeft: 15,
                              fontWeight: "800",
                              color: "#2062AF",
                            }}
                          >
                            ₹ 1,629 Offer Price
                          </span>
                        </div>
                      </div>
                      <div className={styles.mobilePackage}>
                        <div style={{ display: "flex" }}>
                          <BsCaretDownFill
                            size={18}
                            style={{ marginTop: 0 }}
                            color="#156508"
                          />{" "}
                          <span
                            style={{
                              marginLeft: 10,
                              color: "#2062AF",
                              fontSize: 12,
                            }}
                          >
                            Package{" "}
                          </span>
                        </div>
                      </div>
                      <h6
                        style={{
                          marginTop: 10,
                          fontWeight: "800",
                          fontSize: 16,
                          color: "#002E6E",
                        }}
                      >
                        {serviceItem.name}
                      </h6>
                      <div style={{ display: "flex", color: "#2062AF" }}>
                        <FaStar
                          size={19}
                          style={{ marginRight: 10, color: "#F79219" }}
                        />
                        4.83 (4.4 M bookings)
                      </div>
                      <div
                        style={{
                          fontSize: 19,
                          marginTop: 10,
                          color: "#466590",
                        }}
                      >
                        Original Price{" "}
                        <span style={{ textDecoration: "line-through" }}>
                          ₹1,629
                        </span>
                      </div>
                      <div className={styles.mobilePackage}>
                        <div style={{ display: "flex" }}>
                          <span
                            style={{
                              marginLeft: 5,
                              fontWeight: "800",
                              color: "#2062AF",
                              fontSize: 15,
                            }}
                          >
                            ₹ 1,629 Offer Price
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className={styles.productItemImg}>
                      <Image
                        src={
                          "https://meridian-spa.co.uk/wp-content/uploads/2024/08/How-Does-Leg-Massage-Work.webp"
                        }
                        className={styles.productImg}
                      />
                    </div>
                  </div>

                  <hr style={{ borderTop: "2px dashed #66D6FF" }} />

                  <div className={styles.productDescriptionRow}>
                    <div className={styles.productDescriptionContent}>
                      <ul
                        style={{
                          fontFamily: "Inter, sans-serif",
                          fontSize: 13,
                        }}
                      >
                        <li>Waxing: Full Body </li>
                        <li>Facial: Crave Beauty banana Hydrating facial </li>
                        <li>
                          Threading: Eye Brow Threading, Upper Leave Threading{" "}
                        </li>
                      </ul>

                      <div
                        style={{
                          marginLeft: 5,
                          color: "#07448E",
                          textDecoration: "underline",
                          cursor: "pointer",
                        }}
                        onClick={() => navigate("/productDetail")}
                      >
                        Learn More
                      </div>
                    </div>

                    <div className={styles.productDescriptionveideo}>
                      <div className={styles.buttonPlay} onClick={openModal}>
                        <FaPlay size={20} color="#fff" />
                      </div>

                      <button className={styles.btnAddCart}>+ Add</button>
                    </div>
                  </div>
                </div>

                <hr style={{ color: "#66D6FF" }} />
              </>
            ))}
        </div>

        <div className={styles.productCart}>
          <div className={styles.cartlist}>
            <h4 style={{ marginTop: 10, marginLeft: 10, color: "#002E6E" }}>
              Cart
            </h4>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <p>Complete chocalate waring</p>
              <div
                style={{
                  display: "flex",
                  width: 70,
                  height: 30,
                  borderRadius: 10,
                  border: "2px solid #07448E",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <GoPlus style={{ marginLeft: 5, color: "#07448E" }} />
                <span
                  style={{ fontFamily: "Inter, sans-serif", color: "#07448E" }}
                >
                  1
                </span>
                <GrSubtract
                  style={{
                    marginRight: 5,
                    fontFamily: "Inter, sans-serif",
                    color: "#07448E",
                  }}
                />
              </div>
              <span
                style={{
                  color: "#002E6E",
                  fontFamily: "Inter, sans-serif",
                  fontSize: 19,
                }}
              >
                ₹1000
              </span>
            </div>

            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <p>Complete chocalate waring</p>
              <div
                style={{
                  display: "flex",
                  width: 70,
                  height: 30,
                  borderRadius: 10,
                  border: "2px solid #07448E",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <GoPlus style={{ marginLeft: 5, color: "#07448E" }} />
                <span
                  style={{ fontFamily: "Inter, sans-serif", color: "#07448E" }}
                >
                  1
                </span>
                <GrSubtract
                  style={{
                    marginRight: 5,
                    fontFamily: "Inter, sans-serif",
                    color: "#07448E",
                  }}
                />
              </div>
              <span
                style={{
                  color: "#002E6E",
                  fontFamily: "Inter, sans-serif",
                  fontSize: 19,
                }}
              >
                ₹1000
              </span>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <p>Complete chocalate waring</p>
              <div
                style={{
                  display: "flex",
                  width: 70,
                  height: 30,
                  borderRadius: 10,
                  border: "2px solid #07448E",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <GoPlus style={{ marginLeft: 5, color: "#07448E" }} />
                <span
                  style={{ fontFamily: "Inter, sans-serif", color: "#07448E" }}
                >
                  1
                </span>
                <GrSubtract
                  style={{
                    marginRight: 5,
                    fontFamily: "Inter, sans-serif",
                    color: "#07448E",
                  }}
                />
              </div>
              <span
                style={{
                  color: "#002E6E",
                  fontFamily: "Inter, sans-serif",
                  fontSize: 19,
                }}
              >
                ₹1000
              </span>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                background: "#002E6E",
                padding: 8,
                borderRadius: 10,
                color: "#fff",
                alignItems: "center",
                fontSize: 12,
              }}
            >
              View Cart
              <span
                style={{
                  color: "#fff",
                  fontFamily: "Inter, sans-serif",
                  fontSize: 14,
                }}
              >
                ₹1000
              </span>
            </div>
          </div>

          <div
            style={{
              width: "100%",
              border: "2px solid #66D6FF",
              marginTop: 10,
              height: 150,
              borderRadius: 10,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <FaCartPlus size={50} color="#777" />
            <h3
              style={{
                color: "#07448E",
                fontFamily: "Inter, sans-serif",
                marginTop: 10,
              }}
            >
              No Items In Your Cart
            </h3>
          </div>

          <div
            style={{
              width: "100%",
              border: "2px solid #66D6FF",
              marginTop: 10,
              height: 170,
              borderRadius: 10,
              padding: 10,
            }}
          >
            <h5 style={{ color: "#002E6E" }}>HC Promise</h5>

            <p style={{ color: "#2062AF" }}>
              <FaCheck color="#F79219" /> 4.5+ Rated Beauticians
            </p>
            <p style={{ color: "#2062AF" }}>
              <FaCheck color="#F79219" /> Luxury Salon Experience
            </p>
            <p style={{ color: "#2062AF" }}>
              <FaCheck color="#F79219" /> Premium Branded Products
            </p>
          </div>
        </div>
      </div>

      {/* Modal */}
      {isOpen && (
        <div style={styless.overlay}>
          <div style={styless.modal}>
            <button onClick={closeModal} style={styless.closeButton}>
              ✖
            </button>
            <br></br>
            <br></br>

            <Player
              autoPlay
              muted
              playsInline
              style={{
                width: "100%",
                height: 250,
                marginTop: 10,
                position: "relative",
              }}
            >
              <source src="https://media.w3.org/2010/05/sintel/trailer_hd.mp4" />
            </Player>
          </div>
        </div>
      )}
    </div>
  );
}

// CSS styles in JS
const styless = {
  button: {
    fontSize: "18px",
    padding: "10px 20px",
    cursor: "pointer",
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0,0,0,0.6)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  modal: {
    backgroundColor: "#fff",
    width: "90%",
    maxWidth: "600px",

    padding: "10px",
    position: "relative",
    borderRadius: "8px",
  },
  closeButton: {
    position: "absolute",
    top: 10,
    right: 10,
    background: "transparent",
    border: "none",
    fontSize: "20px",
    cursor: "pointer",
  },
};
